import axios from "axios";
import vm from "../main";
import help from "../util/help";
// 判断本地和线上接口
// const HOST = ''

const LOCALHOST = "http://jofph.mre.work:802/"; // mock数据
const TESTHOST = "https://jofph.mre.press/";
const HOST = "https://www.jofph.com/";

axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";
axios.defaults.headers.get["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";

//拦截器
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      vm.$store._actions.updateLoading[0](false);
      switch (error.response.status) {
        case 401:
          // 返回 401 清除token信息并跳转到登录页面
          if (!window.location.href.includes("/access/login")) {
            vm.$message.error("登陆过期");
            window.location.href = "/#/access/login";
          }
          break;
        case 400:
          vm.$message.error(error.response.data.message);
          break;
        case 500:
          vm.$message.error("服务器错误，请联系管理员！");
          break;
      }
    }
    return Promise.reject(error.response.data); // 返回接口返回的错误信息
  }
);

/**
 * 过滤请求失败的情况接口
 * @param {*} data
 */
function warp(res, flag = true) {
  vm.$store._actions.updateLoading[0](false);
  vm.$store._actions.updateContentLoad[0](false);
  if (res.data.status === 200) {
    res.data.data = res.data.data || {};
    res.data.data.isSuccess = true;
  } else {
    if (flag) {
      vm.$message.error(res.data.message);
    }
  }
  return res.data.data;
}

/**
 * 用户登录接口
 * @param {username, password} data
 */
function login(data) {
  const api = "imr-user/user/login";
  const URL = getUrl(api);
  return axios.post(URL, data).then((res) => {
    // 请求完成统一修改loading状态
    vm.$store._actions.updateLoading[0](false);
    if (res.status === 200) {
      if (res.data.status === 200) {
        localStorage.setItem("token", res.data.data.Authorization);
        return Object.assign(res.data.data, { loginSuccess: true });
      } else if (res.data.status === 500) {
        vm.$message.error("服务器错误，请联系管理员！");
      } else {
        vm.$message.error(res.data.message);
        return {
          errorMsg: res.data.message,
        };
      }
    } else {
      throw res;
    }
  });
}

/**
 * 用户注册接口
 * @param {*} data
 */
function register(data) {
  const api = "imr-user/user/registered";
  const URL = getUrl(api);
  return axios.post(URL, data).then((res) => {
    // 请求完成统一修改loading状态
    vm.$store._actions.updateLoading[0](false);
    if (res.status === 200) {
      if (res.data.status === 200) {
        return Object.assign(res.data.data || {}, { loginSuccess: true });
      } else {
        vm.$message.error(res.data.message);
        return {
          errorMsg: res.data.message,
        };
      }
    } else {
      throw res;
    }
  });
}

// 流post
function octetPost(url, data = {}) {
  const URL = getUrl(url);
  axios.defaults.headers.common["Authorization"] =
    localStorage.getItem("token");
  return axios({
    url: URL,
    method: "post",
    data,
    responseType: "blob", // 表明返回服务器返回的数据类型
  }).then((res) => {
    // const fileName = res.headers['Content-Disposition'].split('=')[1]
    return {
      file: res.data,
      // fileName
    };
  });
}

// 流post410
function octetPost410(url, data = {}) {
  const URL = "http://192.168.4.10:9001/" + url;
  axios.defaults.headers.common["Authorization"] =
    localStorage.getItem("token");
  return axios({
    url: URL,
    method: "post",
    data,
    responseType: "blob", // 表明返回服务器返回的数据类型
  }).then((res) => {
    // const fileName = res.headers['Content-Disposition'].split('=')[1]
    return {
      file: res.data,
      // fileName
    };
  });
}

// 流get
function octetget(url, data = {}) {
  const URL = getUrl(url);
  axios.defaults.headers.common["Authorization"] =
    localStorage.getItem("token");
  const params = help.dataInit(data);
  return axios({
    url: URL,
    method: "get",
    params,
    responseType: "blob", // 表明返回服务器返回的数据类型
  }).then((res) => {
    // const fileName = res.headers['Content-Disposition'] ? res.headers['Content-Disposition'].split('=')[1] : ''
    // console.log(res)
    // if (fileName) {
    //   return { file: res.data, fileName }
    // } else {
    return { file: res.data };
    // }
  });
}

// post方法
function post(url, data = {}) {
  const URL = getUrl(url);
  axios.defaults.headers.common["Authorization"] =
    localStorage.getItem("token");
  const params = help.dataInit(data);
  return axios.post(URL, params).then((res) => {
    return warp(res);
  });
}

// put方法
function put(url, data = {}) {
  const URL = getUrl(url);
  axios.defaults.headers.common["Authorization"] =
    localStorage.getItem("token");
  const params = help.dataInit(data);
  return axios.put(URL, params).then((res) => {
    return warp(res);
  });
}

// get方法
function get(url, data = {}) {
  const URL = getUrl(url);
  axios.defaults.headers.common["Authorization"] =
    localStorage.getItem("token");
  const params = help.dataInit(data);
  return axios.get(URL, { params }, false).then((res) => {
    return warp(res, false);
  });
}

// 替换路由为对应项目路由
function getUrl(api) {
  if (location.host.includes("10.10") || location.host.includes("localhost")) {
    return TESTHOST + api;
  } else if (location.host.includes("mre.press")) {
    return TESTHOST + api;
  } else if (
    location.host.includes("jofph.com") ||
    location.host.includes("8.219.49.67")
  ) {
    return HOST + api;
  } else {
    return LOCALHOST + api;
  }
}

const http = {
  register,
  login,
  post,
  put,
  get,
  octetPost,
  octetget,
  octetPost410,
};

export default http;
